import React from "react";
import forEach from "lodash/forEach";
import map from "lodash/map";
import uniq from "lodash/uniq";
import { connect } from "react-redux";
import { Button, Tag, Modal, Table } from "antd";
import { withNamespaces } from "react-i18next";

import classes from "./WizardConfig.css";

import { getPermutedBlocksActiveCSVRequest } from "../../api/requests";
import { logout } from "../../reducers/user/actions";

const colors = [
  "blue",
  "green",
  "purple",
  "cyan",
  "lime",
  "geekblue",
  "gold",
  "volcano",
];
const colorsCohort = ["#317f82", "#2db7f5", "#87d068", "#108ee9", "#cd32bc"];

class PermutedBlocksCSV extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      permutedBlocksActive: [],
      treatment: [],
      cohorts: [],
      isShow: false,
      tableHeaders: [],
    };
  }

  componentDidMount() {}

  setData = async () => {
    this.setState({ isLoading: true });
    const { data } = await getPermutedBlocksActiveCSVRequest();

    const permutedBlocksActive = data.split("\n");
    const tableHeaders = permutedBlocksActive.shift().split(",");

    const treatment = [];
    const cohorts = [];

    this.setState({
      permutedBlocksActive: map(permutedBlocksActive, (item) => {
        const row = item.split(",");
        const result = {};

        forEach(item.split(","), (val, i) => {
          if (tableHeaders[i] === "treatment") {
            treatment.push(val);
          }
          if (tableHeaders[i] === "cohort") {
            cohorts.push(val);
          }

          result[tableHeaders[i]] = val;
        });

        return result;
      }),
    });

    this.setState({
      isLoading: false,
      treatment: uniq(treatment),
      cohorts: uniq(cohorts),
      tableHeaders,
    });
  };

  render() {
    const {
      isShow,
      isLoading,
      permutedBlocksActive,
      treatment,
      cohorts,
      tableHeaders,
    } = this.state;

    return (
      <div>
        <Button
          type="primary"
          size="small"
          onClick={() => {
            this.setData();
            this.setState({ isShow: true });
          }}
        >
          Show active permuted blocks (table)
        </Button>
        <Modal
          visible={isShow}
          onCancel={() => {
            this.setState({ isShow: false });
          }}
          footer={null}
          width={767}
        >
          <h3 className="headline-default">{this.props.i18n.t("NamespaceWizardConfig:Permuted blocks config")}</h3>

          <Table
            rowKey="index"
            pagination={false}
            loading={isLoading}
            dataSource={permutedBlocksActive}
            columns={map(tableHeaders, (item, key) => {
              if (item === "treatment") {
                return {
                  title: item,
                  dataIndex: item,
                  key: item,
                  render: (val) => (
                    <div>
                      {val && (
                        <Tag color={colors[treatment.indexOf(val)]}>{val}</Tag>
                      )}
                    </div>
                  ),
                };
              }
              if (item === "cohort") {
                return {
                  title: item,
                  dataIndex: item,
                  key: item,
                  render: (val) => (
                    <div>
                      {val && (
                        <Tag color={colorsCohort[cohorts.indexOf(val)]}>
                          {val}
                        </Tag>
                      )}
                    </div>
                  ),
                };
              }

              return {
                title: item.split('_').join(' '),
                dataIndex: item,
                key: item,
              };
            })}
          />
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = () => ({});
const mapDispatchToProps = { logout };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces()(PermutedBlocksCSV));



// WEBPACK FOOTER //
// ./src/containers/WizardConfig/PermutedBlocksCSV.js